import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IPermissionEditModel, IPermission } from '../models/Permission';
import { environment as ENV } from '../../environments/environment';

@Injectable({ providedIn: "root" })
export class PermissionsService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/permissions` }

    get(): Observable<IPermission[]> {
        return this.http.get<IPermission[]>(this.apiUrl);
    }

    getByRole(role: string): Observable<IPermission[]> {
        return this.http.get<IPermission[]>(`${this.apiUrl}/getForRole(${role})`);
    }

    create(data: IPermissionEditModel): Observable<number> {
        return this.http.post<number>(this.apiUrl, data);
    }

    update(id: number, data: IPermissionEditModel): Observable<any> {
        return this.http.put(`${this.apiUrl}/${id}`, data);
    }

    delete(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete(url);
    }
}
